import { Injectable } from '@angular/core';
import { PaginatedResult } from 'src/app/shared/grid/paginate.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPaginatedServiceParamters } from '../core/models/ITable';
import { PendingReturn } from '../core/models/PendingReturn';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PendingReturnService {
  constructor(private apiService: ApiService) {}

  getAllPaginated(
    paginatedArguments: IPaginatedServiceParamters,
  ): Observable<PaginatedResult<PendingReturn[]>> {
    const params = {...paginatedArguments};
    if (params.ReturnFrom) {
      params.ReturnFrom = this.formatDateString(params.ReturnFrom);
    }
    if (params.ReturnTo) {
      params.ReturnTo = this.formatDateString(params.ReturnTo);
    }
    return this.apiService.getPaginated('/api/Return/pending', params);
  }
  private formatDateString(dateStr: string): string {
    const date = new Date(dateStr);
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  }

  getPendingReturn(id) {
    return this.apiService.get(`/api/Return/Pending/${id}`);
  }

  downloadReturnsCSV(returnParams: any): Observable<Blob> {
    return this.apiService.getBlob('/api/Return/DownloadPendingReturnsCSV', returnParams);
  }

  downloadReturnsExcel(returnParams: any): Observable<Blob> {
    return this.apiService.getBlob('/api/Return/DownloadPendingReturnsExcel', returnParams);
  }

  // Método optimizado que obtiene solo count usando aggregates del backend
  getPendingReturnQuantity(): Observable<{ count: number; amount: number }> {
    // Usamos pageSize=1 para optimizar, pero el backend devuelve totalItems en pagination
    return this.apiService.getPaginated('/api/Return/pending', { 
      query: '', 
      pageNumber: 1, 
      pageSize: 1
    }).pipe(
      map((response: any) => ({
        count: response.pagination?.totalItems || 0,
        amount: 0 // El backend no devuelve suma agregada, requiere consulta personalizada
      }))
    );
  }
}
